import fetch             from './utils/browser-fetch';
import busyActionFactory from './busy';
import { addError }      from './errors-dux';
import { setUserData }   from './user-dux';
import { setUserLocale } from './components/routes/profile/profile-dux';
import Errors            from './errors';
import { setSSOConfig }  from './components/routes/sso-authenticated/sso-authenticated-dux';


/*******************************************************************************
 * Initial state
 */
const initialState = {
    passwordRules: {},
    locale: {
        code: 'en-US', // default locale,
        dir: 'ltr'
    },
    localeList: [],
    bundleList: {},
    clientBranding: {
        activationFields: []
    },
    busyFetchingClientData: false
};


/*******************************************************************************
 * Action types
 */
export const SET_CLIENT_DATA = 'SET_CLIENT_DATA';
export const SET_BUNDLE_DATA = 'SET_BUNDLE_DATA';
export const BUSY_FETCHING_CLIENT_DATA = 'BUSY_FETCHING_CLIENT_DATA';


/*******************************************************************************
 * Reducer
 */
export default function clientData( state = initialState, action ) {
    switch ( action.type ) {
        case SET_CLIENT_DATA:
            const { clientData } = action;
            return {
                ...state,
                passwordRules: clientData.passwordRules,
                localeList: clientData.localeList,
                bundleList: clientData.bundleList,
                clientBranding: clientData.clientBranding,
                clientCountries: clientData.clientCountries
            };

        case SET_BUNDLE_DATA:
            const updatedBundleList = Object.assign( {}, state.bundleList, action.newData.bundleList );

            return {
                ...state,
                bundleList: updatedBundleList
            };

        case BUSY_FETCHING_CLIENT_DATA:
            return {
                ...state,
                busyFetchingClientData: action.busy
            };

        default:
            return state;
    }
}


/*******************************************************************************
 * Action creators
 */

export function getSessionBundleData( bundle ) {
    return dispatch => {
        return new Promise( ( resolve, reject ) => {
            const sessionBundleState = JSON.parse( sessionStorage.getItem( 'bundleState' ) ) || {};

            sessionBundleState.bundleList = sessionBundleState.bundleList || bundle;

            dispatch( setBundleData( sessionBundleState ) );

            resolve();
        } );
    };
}

export function setClientData( clientData ) {
    return ( dispatch ) => {
        dispatch( {
            type: SET_CLIENT_DATA,
            clientData
        } );
    };
}

export function setBundleData( newData ) {
    console.log( 'sessionstoragetest:', sessionStorage );
    const sessionBundleState = JSON.parse( sessionStorage.getItem( 'bundleState' ) ) || {};

    sessionBundleState.bundleList = Object.assign( {}, sessionBundleState.bundleList, newData.bundleList );

    sessionStorage.setItem( 'bundleState', JSON.stringify( sessionBundleState ) );

    return ( dispatch ) => {
        dispatch( {
            type: SET_BUNDLE_DATA,
            newData
        } );
    };
}

export function fetchBundleData( selectedLocale, setUserLocaleFlag ) {
    return dispatch => {
        return fetch( '/api/v1.0/viewConfig/bundle/' + encodeURIComponent( selectedLocale ) )
            .then( ( bundleList ) => {
                dispatch( setBundleData( bundleList ) );
                dispatch( setUserData( { locale: bundleList.bundleList[ selectedLocale ].locale } ) );
                setUserLocaleFlag && dispatch( setUserLocale( selectedLocale ) );
            } )
            .catch( ( error ) => {
                dispatch( addError( error, Errors.ERROR_CLIENT_FETCH_BUNDLE_DATA ) );
            } );
    };
}


const busyFetchingClientData = busyActionFactory( BUSY_FETCHING_CLIENT_DATA );
export function fetchClientData() {
    return dispatch => {
        dispatch( busyFetchingClientData( true ) );

        return fetch( '/api/v1.0/viewConfig/client' )
            .then( ( clientData ) => {
                dispatch( setClientData( clientData ) );
                dispatch( busyFetchingClientData( false ) );
                dispatch( setSSOConfig( clientData.ssoConfig ) );
            } )
            .catch( ( error ) => {
                dispatch( addError( error, Errors.ERROR_CLIENT_FETCHCLIENTDATA ) );
                dispatch( busyFetchingClientData( false ) );
            } );
    };
}
